let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("awqCy"), load("ffEVr"), load("943D1")]).then(() => parcelRequire('ddp7n'));